import styled from 'styled-components';
import { Button, buttonColors } from '../Button';
import { Input } from '../Input';

export const StyledNumberInput = styled(Input)({
  '-moz-appearance': 'textfield',
  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    margin: 0,
    '-webkit-appearance': 'none',
  },
});

export const Wrapper = styled.div({
  position: 'relative',
});

export const ActionButton = styled(Button).attrs({
  color: buttonColors.GHOST,
  type: 'button',
})({
  aspectRatio: '1 / 1',
  border: 'none',
  '&:disabled': {
    cursor: 'default',
  },
});

export const ButtonDivider = styled.div({
  width: '1px',
  padding: '10px 0',
  borderLeft: '1px solid #E0E0E0',
  boxSizing: 'border-box',
});
